import { ProductInventoryDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { observeProductInventories } from 'src/utils/firebase/firebase-short-cut';

const useProductInventories = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [productInventories, setProductInventories] = useState<ProductInventoryDoc[]>([]);

  useEffect(() => {
    const subscription = observeProductInventories([
      ['deletedAt', '==', null],
      ['active', '==', true],
    ]).subscribe((inventories0) => {
      const inventories = inventories0.sort((a, b) => a.inventoryName.localeCompare(b.inventoryName));
      setProductInventories(inventories);
      setIsLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  return { productInventories, isLoading };
};

export default useProductInventories;
